import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import tippy, { hideAll, inlinePositioning } from 'tippy.js';
export var dropdown = function dropdown() {
  Alpine.data('dropdown', function () {
    return {
      open: false,
      tippyInstance: false,
      init: function init() {
        this.dropdownElement = this.$el;
        this.dropdownButton = this.dropdownElement.querySelector('.a-dropdown__button');
        this.dropdownContent = this.dropdownElement.querySelector('.a-dropdown__content');
        this.createDropdown();
      },
      createDropdown: function createDropdown() {
        var _this = this;
        if (this.dropdownContent) {
          this.tippyInstance = tippy(this.dropdownElement, {
            content: this.dropdownContent,
            arrow: true,
            trigger: 'click',
            triggerTarget: [this.dropdownButton],
            interactive: true,
            allowHTML: true,
            duration: [250, 150],
            inertia: true,
            animation: 'scale',
            placement: 'bottom-start',
            moveTransition: 'transform 0.2s ease-out',
            popperOptions: {
              modifiers: [{
                name: 'flip',
                options: {
                  fallbackPlacements: ['bottom', 'top']
                }
              }]
            },
            plugins: [this.accessibleToggle, inlinePositioning]
          });
          this.tippyInstance.props.onShow = function () {
            _this.open = true;
          };
          this.tippyInstance.props.onHide = function () {
            _this.open = false;
          };
        }
      },
      accessibleToggle: {
        name: 'accessibleToggle',
        defaultValue: true,
        fn: function fn(instance) {
          var state = instance.state,
            show = instance.show,
            hide = instance.hide,
            props = instance.props;
          function toggle() {
            return state.isVisible ? hide() : show();
          }
          function globalKeyDown(event) {
            if (event.keyCode === 27) {
              event.preventDefault();
              hide();
            }
          }
          function onKeyDown(event) {
            var triggerElement = props.triggerTarget;
            if (document.activeElement === triggerElement[0]) {
              if ([13, 32].includes(event.keyCode)) {
                event.preventDefault();
                toggle();
              }
            }
          }
          return {
            onCreate: function onCreate(instance) {
              document.addEventListener('keydown', globalKeyDown);
              instance.reference.addEventListener('keydown', onKeyDown);
            },
            onDestroy: function onDestroy(instance) {
              document.reference.removeEventListener('keydown', globalKeyDown);
              instance.reference.removeEventListener('keydown', onKeyDown);
            },
            onShow: function onShow(instance) {
              hideAll({
                exclude: instance
              });
            }
          };
        }
      },
      bindDropdownIcon: {
        // eslint-disable-next-line func-names
        ':class': function _class() {
          return {
            'rotate-180': this.open
          };
        }
      }
    };
  });
};